import type {
  AlertUnsubscribeMutation,
  AlertUnsubscribeMutationVariables,
} from 'src/types';
import alertUnsubscribeMutation from '../mutation.graphql';
import { useGqlMutation } from 'src/hooks/use-gql-mutation';

export function useAlertUnsubscribeMutation(
  variables: AlertUnsubscribeMutationVariables
) {
  return useGqlMutation<AlertUnsubscribeMutation>({
    mutation: alertUnsubscribeMutation,
    variables,
  });
}
